import { UploadedDocument } from '@urbanx/agx.agencies.client';
import { ApiRequestBody } from 'interfaces/ApiRequestBody';
import AgencyService from 'services/agenciesService';

interface UpdateDocumentRequest extends ApiRequestBody {
  selectedFile: File;
  AgencyId?: string;
  getAuthToken: () => Promise<string>;
}

const UploadPublicDocument = async (
  requestBody: UpdateDocumentRequest
): Promise<UploadedDocument | undefined> => {
  const { AgencyId, selectedFile, getAuthToken } = requestBody;

  if (!AgencyId) return;

  const token = await getAuthToken();
  const service = new AgencyService(token);

  const formdata = new FormData();
  formdata.append('File', selectedFile);

  const result = await service.agencyService.post(
    `UploadPublicDocument?AgencyId=${encodeURIComponent(AgencyId)}`,
    formdata,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }
  );

  return result.data as UploadedDocument;
};

export default UploadPublicDocument;
